/* DCG V3.1.2 · 21 OCT 2026 · the addendum's gate (the filters suite on the draft): the net's "Clear all" forgets the visit's In Stock Only choice first (the guard's forgetStock), so the site's default holds */
/* DCG V3.1.2 · 21 OCT 2026 · the addendum, D-SP-49 (decided by Cole): Shopify's Tags facet (filter.p.tag) shows the tag groups the settings file names, as StorePass's Tag group (the guard's §L) */
/* DCG V3.1.2 · 21 OCT 2026 · the addendum's gate (the filters suite on the draft): a search with In Stock Only on counts its in-stock part, no measure of the whole collection: neither the mismatch nor "capped" is judged on it (flesh-and-blood-sealed-product, In Stock Only turned on, 38 against Shopify's 102, opened the net); "zero" and "failed" still are */
/* DCG V3.1.2 · 21 OCT 2026 · the addendum, item 1 amended (Cole, 21 OCT; docs/PROMPT-V3-1-2-addendum-in-stock-first.md): in stock first across the whole collection: up to 250 products the whole collection in one view (available first) cut into pages of 60 here; over 250 Shopify's two listings stitched (filter.v.availability=1, then =0) where it offers that filter, else its pages each in-stock first; a singles collection under a price sort in Shopify's order; "· N in stock" on the count line; the switch keeps the visitor's choice for the visit through the guard whatever the file's default */
/* DCG V3.1.2 · 21 OCT 2026 · item 1's end gate: under ?in_stock= the net lists the whole collection (the address holds the default off for its page); its switch pressed there takes that hold out of the address */
/* DCG V3.1.2 · 20 OCT 2026 · item 8 (Cole, 20 OCT): every filter Shopify's Search & Discovery offers the collection drawn in StorePass's sidebar, in its skin (a group each: the heading, the collapsible, the values with their counts; Vendor as Brand; a group of one value hidden), chips for what is on, the values in the address as Shopify's own keys (a filtered page is linkable); the one line only where Shopify offers nothing */
/* DCG V3.1.2 · 20 OCT 2026 · item 1 (Cole: In Stock Only on by default, everywhere, remembered): the default In Stock Only narrows nothing for "the whole collection" (a collection StorePass holds only out of stock opens the net, never "No results found"); the net's own In Stock Only follows the default (the visit's choice, the guard's), its switch remembered for the visit, no key in the address for it; an empty in-stock listing by default is shown without it */
/* DCG v2-10-8 · 15 OCT 2026 · item 3a: "capped" opens the net only when paging is broken too (page 2 of the same search asked once: fails, a cursor, empty or a repeat of page 1); item 1: a page or a sort the visitor chose lands on the count line, by the paging script's landing */
/* DCG v2-10-7 · 15 OCT 2026 · over 25,000 products (Magic singles, now reached by "capped") the count line has no total: Shopify's 25,001 is not a count */
/* DCG v2-10-7 · 14 OCT 2026 · D-SP-37 (amendment D PROPOSED) · a fifth way in, "capped": StorePass's count says its one page is the whole search while Shopify holds more (StorePass's change of about 13:00, 14 OCT) */
/* DCG v2-10-6 · 14 OCT 2026 · D-SP-37 (amendments PROPOSED) · a fourth way in, the mismatch (StorePass's count far above Shopify's); the opening sort is the collection's own (its sort_order in the settings file); "In Stock Only" and "Price range", Shopify's storefront filters, on this path */
/* DCG v2-10-5 · 13 OCT 2026 · D-SP-37 (LOCKED as a bridge, Cole 13 OCT) · the listing opens on Shopify's best-selling, the sort control reading "Sort: Sales" (Cole, 13 OCT) */
/* DCG v2-10-4 · 13 OCT 2026 · D-SP-37 (PROPOSED) · Shopify's own listing of a collection when StorePass has nothing for it */
/* =========================================================
   Desert City Games — the collection safety net (D-SP-37, PROPOSED)
   File: assets/dcg-collection-fallback.js

   WHY
   On 13 OCT 2026, 52 of the store's 175 collections returned no product
   from StorePass's search while Shopify held their products
   (docs/CENSUS-collections-storepass-2026-10-13.md): every sealed
   collection, clearance, pre-orders, graded cards. On this theme their
   pages read "No results found". Until StorePass puts that right, and
   whenever StorePass cannot be reached, a collection page must still show
   its products.

   WHAT IT DOES
   On a collection page it listens to what the guard
   (assets/dcg-storepass-guard.js) says about StorePass's own searches. When
   the page's search of the whole collection has nothing, or fails, and
   Shopify says the collection has products, it shows Shopify's own listing
   of the collection in the results: the DCG product card
   (snippets/dcg-product-card.liquid), 60 a page, with Shopify's exact count
   and a pager. The listing is the alternate view
   templates/collection.dcg_fallback.json
   (sections/dcg-collection-fallback.liquid), fetched from
   /collections/<handle>?view=dcg_fallback&page=N&sort_by=...

   WHEN (all three)
   a. The search is of the whole collection: this collection's id, no card
      name, no filter, "In Stock Only" off. (The sort and the page are not
      filters: see "The address" below.)
   b. One of three (the why: on the results container as
      data-dcg-fallback-why, and in the console line):
      zero      StorePass has nothing for it: the page of products is empty
                AND the count StorePass gives for the whole search is 0;
      failed    the request failed: a network error, an answer that is not
                a 200 or cannot be read, or no answer within 8 seconds (the
                guard times it);
      mismatch  (v2-10-6) StorePass's count for the whole search is far
                above Shopify's: more than Shopify's count x 1.25 + 10.
                StorePass then answers with products that are not the
                collection's (on 14 OCT it gave the store's newest products
                for 19 "upcoming new releases" collections). The slack is
                for StorePass's counts, which differ a little from
                Shopify's (one-piece-singles 1,948 against 1,951). Above
                1,000 StorePass's count is an estimate, below the real
                number in every measure of v2-9-1 (a third to nine tenths
                of it), so a large collection does not trip the rule on an
                estimate. StorePass's cards show until its count answers (the
                count comes with, or just after, the page of products).
      capped    (v2-10-7) StorePass hands back one page and says that is
                all, while Shopify holds more: its count for the whole
                search is no more than one page (at most the page size, and
                its pages 1 or none), the page holds no more products than
                that count, and Shopify's count is more than the page's
                products + 10 and more than 60. Since about 13:00 on 14 OCT
                StorePass's count is the page size on every collection over
                60 (One Piece singles: 60 where it was 1,948) and its page 2
                repeats page 1; on mtg-sealed-product the page holds 45 and
                the count says 60. Never on a collection Shopify says holds
                60 or fewer. Its page answer always says count = its own
                products and pages 1, before the change and after; so the
                count answer (with_count=true) is the one read, as for the
                other ways. StorePass's cards show until both have answered.
                v2-10-8 (item 3a): and only when its paging is broken too.
                The other page of the same search is asked for once; the
                net opens if it fails, is a cursor, holds nothing or repeats
                this page (see checkPaging). If its pages work, StorePass's
                own page stays, with no total and a Previous / Next pager.
   c. Liquid says the collection has products: data-dcg-shopify-count on
      the results container is above 0 (the whole collection,
      all_products_count, whatever Shopify filter is in the address).
   NEVER on a search with a card name or a filter that finds nothing; never
   on a page past the end of a collection StorePass does have (its count is
   above 0 then, and within the slack); never on a collection Shopify also
   says is empty. Those read "No results found", as before.

   THE ADDRESS
   Sort and page stay where StorePass keeps them: `sort=` and `page=` in the
   address. StorePass's own sort control is the sort control; the pager here
   puts page=<n> into the address and tells StorePass, as the pager of
   assets/dcg-storepass-paging.js does. StorePass then searches again (and
   again finds nothing); this file reads the sort and the page from that
   request and shows that page of Shopify's listing. So a link that is
   shared, a reload, and the Back button all open the same page.

   THE OPENING SORT (v2-10-5, Cole 13 OCT; v2-10-6: the collection's own)
   With no sort in the address (the customer has chosen none), the listing
   opens on the collection's own opening sort, its sort_order in the local
   settings file (assets/dcg-storepass-settings.json, the file StorePass's
   script reads; it is fetched when the net opens, from the browser's
   cache): "created-desc" opens on Shopify's created-descending, the
   control reading "Sort: Recently Added"; "manual" on Shopify's manual
   order, "Sort: Featured"; every other on best-selling, "Sort: Sales"
   (Shopify has no "in stock first", and best-selling puts what sells
   ahead of what is long sold out). If the file cannot be read, the sort
   StorePass opened the collection on says the same (it is read from the
   same file). Where StorePass's own control does not already read that
   sort, the address is given `sort=<it>` in place (replaceState: no new
   step for Back) and StorePass is told, as the pager tells it; its next
   search carries it, and the listing is already on it. A sort in the
   address (chosen, or a shared link) is followed as before. The StorePass
   path is not touched: none of this happens unless the safety net is shown.

   THE FILTERS (v2-10-6)
   Two of the StorePass path's controls, in the same place and drawn the
   same (copies of StorePass's own "Show" and "Price Range" groups), above
   the one line: "In Stock Only", a switch, on by default as on the
   StorePass path (V3.1.2, item 1: the visit's choice as the guard keeps it;
   filter.v.availability=1 in the address from a link wins); "Price range",
   From / To and Search, which put
   filter.v.price.gte and filter.v.price.lte into the address (the store's
   currency; blank is no bound; the To box shows the collection's highest
   price). "Clear all" in the panel heading (assets/dcg-storepass-filters.js
   keeps it) takes them away. They are Shopify's storefront filters
   (Search & Discovery): the view is asked for with them, Shopify filters
   collection.products and paginates what is left, and the count line and
   the pager are that listing's. The theme filters nothing itself. A
   filter, a sort and a page in the address open the same listing (a shared
   link, a reload, Back). StorePass does not read these keys, so its search
   stays a search of the whole collection and the net stays. A control
   whose filter the collection does not have (collection.filters is empty
   above 5,000 products, and a filter can be switched off) is not shown.

   IN STOCK FIRST (V3.1.2, the addendum; Cole, 21 OCT)
   Every product shows, the available ones first, across the whole
   collection, each part in the sort's order (the guard does the same for
   StorePass's listings, its §K). Up to 250 products (the collection's own
   count, data-dcg-shopify-count), the view comes once for a sort and its
   filters, the whole collection in that order (collection.dcg_fallback,
   paginate by 250), and the pages of 60, their count line and their pager
   are cut and drawn here: a page change asks for nothing. Over 250 (three
   of the net's collections on 21 OCT: one-piece 7,337, trading-card-games
   984, mtg-sealed-product 324), Shopify's own pages of 60
   (collection.dcg_fallback_paged) twice over where its availability filter
   is offered: the in-stock listing (filter.v.availability=1) and the rest
   (=0), stitched as the guard stitches StorePass's; the two listings'
   filter counts are added up for the sidebar. Where that filter is not
   offered (above 5,000 products Shopify offers no filter at all), Shopify's
   pages, each in-stock first. Cole's rule keys on the collection's kind: a
   singles collection (its handle has the word) under a price sort keeps
   Shopify's order, price winning. The count line says the in-stock part:
   "Showing 1-60 of 324 · 278 in stock" (not with In Stock Only on).

   WHAT IS NOT AVAILABLE ON THIS PATH
   The filter groups (the sidebar says so in one line), and the list view
   (the switch is hidden).

   It makes no request to StorePass and changes none of StorePass's own
   nodes; it adds its own beside them and takes them away again if StorePass
   answers with products. If this file does not run, the page is as before.
   ========================================================= */
(function () {
  'use strict';

  window.DCG = window.DCG || {};
  if (window.DCG.collectionFallback) return;

  const ATTR = 'data-dcg-fallback';          // on the results container while Shopify's listing is shown
  const WHY_ATTR = 'data-dcg-fallback-why';  // v2-10-6: and which way the net opened: zero | failed | mismatch | capped (v2-10-7)
  const PAGING_ATTR = 'data-dcg-paging';     // the count line is ours: StorePass's own count and pager are hidden (dcg-storepass.css)
  const VIEW = 'dcg_fallback';
  const HOST = 'dcg-fallback';
  const NOTE = 'dcg-fallback-note';
  const LINE = 'dcg-count';
  const MINE = 'data-dcg-fallback-line';
  const NOTE_TEXT = 'Filters are not available for this collection right now.';
  const FAIL_TEXT = 'These products could not be loaded. Please reload the page.';
  const LOAD_TEXT = 'Loading products…';

  // StorePass's sorts as Shopify's sort_by. A sort with no like in Shopify opens on best-selling.
  const SORTS = {
    'Alphabetical: A-Z': 'title-ascending',
    'Alphabetical: Z-A': 'title-descending',
    'Price: Low-High': 'price-ascending',
    'Price: High-Low': 'price-descending',
    'Recently Added': 'created-descending',
    'Oldest Listings First': 'created-ascending',
    'Sales': 'best-selling',
    'Featured': 'manual'
  };
  // The opening sort (v2-10-6): the collection's sort_order in the settings file, as Shopify's sort_by and as
  // StorePass's name for it (its sort control and the address). Every sort_order not named here opens on Sales.
  const SALES = { by: 'best-selling', name: 'Sales' };                 // v2-10-5: it was title-ascending (A-Z) in v2-10-4
  const OPENINGS = {
    'created-desc': { by: 'created-descending', name: 'Recently Added' },
    manual: { by: 'manual', name: 'Featured' }
  };
  // The mismatch (v2-10-6): StorePass's count for the whole collection above Shopify's count x 1.25 + 10
  const SLACK_TIMES = 1.25, SLACK_PLUS = 10;
  // Capped (v2-10-7): Shopify must hold more than the page's products + 10, and more than 60
  const CAPPED_PLUS = 10, CAPPED_NEVER_TO = 60;
  // Shopify counts a collection up to 25,000 and prints 25,001 above it (Magic singles): not a count, not shown
  const SHOPIFY_COUNTS_TO = 25000;
  // Shopify's storefront filter keys (Search & Discovery), as they stand in the address and in the view's address
  const KEYS = { stock: 'filter.v.availability', gte: 'filter.v.price.gte', lte: 'filter.v.price.lte' };
  // V3.1.2, the addendum: in stock first across the whole collection (see IN STOCK FIRST above)
  const VIEW_PAGED = 'dcg_fallback_paged';   // the view of 60 a page, for a collection over WHOLE_MOST
  const WHOLE_MOST = 250;                     // Shopify's most a page: a collection this size or under comes in one answer
  const NET_SIZE = 60;
  const singlesHandle = h => /(^|-)singles?(-|$)/i.test(String(h || ''));
  // Cole's rule: a singles collection under a price sort keeps Shopify's order; every other order is in-stock first
  const grouped = (c, by) => !(singlesHandle(c.handle) && /^price-/.test(String(by || '')));
  const CONTROLS = 'dcg-fbf';                 // our two controls, above the one line
  const CONTROLS_ATTR = 'data-dcg-fallback-filters';
  const MINUS = 'M19,13H5V11H19V13Z', PLUS = 'M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z';   // a group's open / shut mark, as StorePass draws it

  const listing = () => document.getElementById('product-listing-container');
  const fmt = n => { try { return Number(n).toLocaleString('en-CA'); } catch (_) { return String(n); } };
  const reduceMotion = () => { try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (_) { return false; } };
  const make = (tag, cls, attrs) => {
    const node = document.createElement(tag);
    if (cls) node.className = cls;
    if (attrs) Object.keys(attrs).forEach(k => node.setAttribute(k, attrs[k]));
    return node;
  };

  // What Liquid wrote about this collection (snippets/store-pass-results.liquid). null on any other page.
  function collection() {
    const root = listing();
    if (!root) return null;
    const handle = root.getAttribute('data-dcg-collection-handle');
    const id = root.getAttribute('data-collection-id');
    if (!handle || !/^\d+$/.test(String(id || ''))) return null;
    const count = parseInt(root.getAttribute('data-dcg-shopify-count'), 10);
    return { root: root, handle: handle, id: String(id), count: count > 0 ? count : 0 };
  }

  // ── Which search is which (the same lists as assets/dcg-storepass-paging.js) ──
  // keys that do not change what a search holds
  const PASSIVE = ['page', 'skip', 'with_count', 'no_track', 'shopify_page_parameters'];
  // keys a search of a whole collection carries with a value
  const PLAIN = ['store_id', 'mongo', 'override_buylist_gt_price', 'product_line', 'sort', 'limit', 'fields', 'convert_to_currency', 'round_price', 'shopify_collection_id'];
  const mine = (query, c) => String(query.shopify_collection_id || '') === c.id;
  // V3.1.2 (item 1; Cole, 20 OCT: In Stock Only on by default): the default In Stock Only narrows nothing the visitor
  // chose. With it on, a collection whose products StorePass holds only out of stock has an empty first page and a count
  // of 0: that is the net's "zero" (Shopify's listing), never "No results found".
  function stockByDefault() {
    try { const g = window.DCG.storepassGuard; return !!(g && typeof g.stockDefaultOn === 'function' && g.stockDefaultOn()); } catch (_) { return false; }
  }
  // The whole collection, nothing narrowing it: no card name, no filter, no "In Stock Only" (but the default's), no
  // price bound, no tag.
  function plain(query) {
    if (query.product_line && query.product_line !== 'All') return false;
    const stockIsDefault = stockByDefault();
    for (const k of Object.keys(query)) {
      if (PLAIN.indexOf(k) !== -1 || PASSIVE.indexOf(k) !== -1) continue;
      if (k === 'in_stock' && stockIsDefault) continue;
      if (String(query[k] === null || query[k] === undefined ? '' : query[k]) !== '') return false;
    }
    return true;
  }
  const keyOf = query => Object.keys(query).filter(k => PASSIVE.indexOf(k) === -1).sort().map(k => k + '=' + query[k]).join('&');
  function pageOf(query) {
    const p = parseInt(query.page, 10);
    if (p >= 1) return p;
    const size = parseInt(query.limit, 10), skip = parseInt(query.skip, 10);
    if (skip > 0 && size > 0) return Math.floor(skip / size) + 1;
    return 1;
  }
  // Has the customer chosen a sort? StorePass writes a chosen sort into the address before it searches; the sort
  // a collection opens on (its sort_order in the settings file) is in its searches but not in the address.
  function chosen() {
    try { const q = new URLSearchParams(window.location.search); return !!(q.get('sort') || q.get('sort_order')); } catch (_) { return false; }
  }
  const openingBy = () => (opening || SALES).by;
  const sortOf = query => (chosen() ? SORTS[String(query.sort || '')] || openingBy() : openingBy());
  // the sort and the page as the address has them (Back, Forward, a filter changed here)
  function fromAddress() {
    const q = new URLSearchParams(window.location.search);
    const p = parseInt(q.get('page'), 10);
    return { sort: chosen() ? SORTS[String(q.get('sort') || '')] || openingBy() : openingBy(), page: p >= 1 ? p : 1 };
  }

  // ── The mismatch (v2-10-6) ──
  const limitOf = c => c.count * SLACK_TIMES + SLACK_PLUS;
  const over = (count, c) => typeof count === 'number' && c.count > 0 && count > limitOf(c);

  // ── Capped (v2-10-7) ──
  // a: { products, count, pages } for one search (the page answer's products, the count answer's count and pages)
  const onePage = (a, size) => typeof a.count === 'number' && a.count > 0 && typeof a.products === 'number' &&
    size > 0 && a.count <= size && !(a.pages > 1) && a.products <= a.count;
  const cappedOf = (a, size, c) => onePage(a, size) && c.count > CAPPED_NEVER_TO && c.count > a.products + CAPPED_PLUS;

  // ── Is paging broken too? (v2-10-8, item 3a, amends v2-10-7) ──
  // A capped search opens the net only when StorePass's paging is broken as well. With its dashboard switch "Use
  // Shopify for initial collection results" off, the count is still the page size but page 2 holds other cards,
  // and StorePass's own path (its filters, with the Previous / Next pager of assets/dcg-storepass-paging.js) is
  // kept. So the other page of the same search (page 2, or page 1 from a later page) is asked for once, quietly
  // (DCG.storepassGuard.quietSearch: not announced, so no one takes it for the listing's own search). Paging is
  // broken, and the net opens "capped", when that page:
  //   fails (no answer in 8 s, not a 200, not readable)          -> 'failed'
  //   is a cursor (nextPageParameters.page_info: the switch on)  -> 'cursor'
  //   holds nothing                                              -> 'empty'
  //   repeats this page (more than half of its cards are here)   -> 'repeats'
  // Otherwise 'works'. Asked once a page view (the verdict is the collection's: the switch is the store's), and
  // said in the console either way. StorePass's cards stay on screen while it is asked.
  let paging = null;                 // null | 'checking' | 'works' | 'failed' | 'cursor' | 'empty' | 'repeats'
  let pagingSaid = '';
  function checkPaging(a, q, c) {
    if (paging !== null) return paging;
    const guard = window.DCG.storepassGuard;
    if (!a.endpoint || !guard || typeof guard.quietSearch !== 'function') { paging = 'failed'; return paging; }
    paging = 'checking';
    const here = pageOf(q), other = here === 1 ? 2 : 1;
    const params = new URLSearchParams();
    Object.keys(q).forEach(k => { if (['page', 'skip', 'with_count', 'no_track'].indexOf(k) === -1) params.set(k, q[k]); });
    params.set('page', String(other));
    const mineIds = new Set(a.ids || []);
    const judge = r => {
      if (paging !== 'checking') return;
      let why;
      if (!r) why = 'failed';
      else if (r.cursor) why = 'cursor';
      else if (!r.products.length) why = 'empty';
      else why = r.products.filter(id => mineIds.has(id)).length * 2 > r.products.length ? 'repeats' : 'works';
      paging = why;
      const n = r ? r.products.length : 0, same = r ? r.products.filter(id => mineIds.has(id)).length : 0;
      pagingSaid = 'DCG: collection ' + c.handle + ': StorePass counts one page (' + a.count + ') where Shopify has ' + fmt(c.count) + '; its page ' + other + ' of the same search ' +
        (why === 'failed' ? 'failed' : why === 'cursor' ? 'is a cursor (nextPageParameters.page_info)' : why === 'empty' ? 'holds nothing' : 'holds ' + n + ', ' + same + ' of them on page ' + here) +
        (why === 'works' ? ': its pages work, StorePass\'s own page stays (no total, Previous / Next)' : ': paging is broken, the net opens (capped)');
      try { console.info(pagingSaid); } catch (_) {}
      recheck();
    };
    guard.quietSearch(a.endpoint + '?' + params.toString()).then(judge, () => judge(null));
    // never left asking: the quiet search gives up after 8 s; anything that has not answered in 10 s is "failed"
    setTimeout(() => judge(null), 10000);
    return paging;
  }
  // the check has answered: the latest search of the whole collection is judged again
  let latest = null;                 // the query of the latest search of the whole collection with both answers in
  function recheck() {
    const c = collection();
    if (!c || !latest || mismatch !== null || paging === 'checking' || paging === 'works') return;
    if (String(latest.in_stock || '') !== '') return;          // the addendum's gate: an in-stock count is not the collection's
    const a = answers.get(keyOf(latest));
    if (!a || typeof a.count !== 'number' || typeof a.products !== 'number' || !cappedOf(a, parseInt(latest.limit, 10) || 0, c)) return;
    capped = { products: a.products, count: a.count, paging: paging };
    activate('capped', latest);
  }

  // ── The opening sort (v2-10-6): the collection's sort_order in the settings file ──
  let opening = null;                // { by, name, from }, once known
  let openingAsk = null;
  // what StorePass opened the collection on says the same, read from the same file (used if the file cannot be read)
  const bySearch = query => {
    const s = String((query && query.sort) || '');
    return Object.assign({ from: 'search' }, s === 'Recently Added' ? OPENINGS['created-desc'] : s === 'Featured' ? OPENINGS.manual : SALES);
  };
  function readOpening(c, query) {
    if (openingAsk) return openingAsk;
    const guess = bySearch(query);
    let url = null;
    try { const el = document.getElementById('storepass-search-settings-json'); url = el ? el.getAttribute('data-url') : null; } catch (_) {}
    const ask = url ? window.fetch(url, { credentials: 'same-origin' }).then(r => (r.ok ? r.json() : null)) : Promise.resolve(null);
    openingAsk = ask.then(s => {
      const store = s && s.store;
      if (!store) return guess;
      const all = [].concat(store.shopify_smart_collections || [], store.shopify_custom_collections || []);
      const mine = all.filter(x => x && String(x.id) === c.id)[0];
      if (!mine) return guess;
      return Object.assign({ from: 'settings', sortOrder: String(mine.sort_order || '') }, OPENINGS[String(mine.sort_order || '')] || SALES);
    }, () => guess).then(o => { opening = o; return o; });
    return openingAsk;
  }

  // ── The filters (v2-10-6): Shopify's, from the address ──
  // V3.1.2 (item 1; Cole, 20 OCT: In Stock Only on by default, everywhere, remembered): two readings. What the address
  // carries (addressFilters: a shared link's filters, those set here; what "Clear all" and the filter count see), and
  // what is in force (filters): the same, but In Stock Only, where the address does not say it, is the site's default
  // as the guard keeps it for the visit (on, or off once the visitor has switched it off; dcg-storepass-guard.js §I).
  // The switch here is the visitor's choice like StorePass's own: it is remembered for the visit, and the address
  // keeps no key for it. When the default's in-stock listing is empty (nothing of the collection is in stock with
  // Shopify either), the listing is shown without it and the switch reads off: the page is never empty for the default.
  // V3.1.2 (item 8): and every other Shopify filter in the address (filter.p.product_type, filter.p.vendor, filter.p.tag,
  // filter.v.option.*, filter.p.m.*), as [key, value] pairs in the address's order, a key as often as it is there
  const isFacetKey = k => /^filter\./.test(k) && k !== KEYS.stock && k !== KEYS.gte && k !== KEYS.lte;
  function addressFilters() {
    try {
      const q = new URLSearchParams(window.location.search);
      const facets = [];
      q.forEach((v, k) => { if (isFacetKey(k) && v !== '') facets.push([k, v]); });
      return { stock: q.get(KEYS.stock) || '', gte: q.get(KEYS.gte) || '', lte: q.get(KEYS.lte) || '', facets };
    } catch (_) { return { stock: '', gte: '', lte: '', facets: [] }; }
  }
  // the address's Shopify filters put as f says (the other keys kept)
  function writeFilters(url, f) {
    const p = url.searchParams;
    [['stock', KEYS.stock], ['gte', KEYS.gte], ['lte', KEYS.lte]].forEach(([k, key]) => { if (f[k]) p.set(key, f[k]); else p.delete(key); });
    Array.from(p.keys()).filter(isFacetKey).forEach(k => p.delete(k));
    (f.facets || []).forEach(([k, v]) => p.append(k, v));
  }
  let stockDropped = false;          // the default's in-stock listing was empty: shown without it
  const addressHasStock = () => { try { return new URLSearchParams(window.location.search).has(KEYS.stock); } catch (_) { return false; } };
  function filters() {
    const f = addressFilters();
    // (a collection with no In Stock filter among Shopify's: none; until the first view says, the default is asked for)
    if (!addressHasStock()) f.stock = (stockByDefault() && !stockDropped && !(offer && !offer.stock)) ? ((offer && offer.stockValue) || '1') : '';
    return f;
  }
  // (the addendum's gate, 21 OCT) In Stock Only on by the visitor's choice kept for the visit (the guard's stockChosen:
  // the visit's "on", the file's default off) with no key in the address: a filter the visitor added, as the key is (its
  // chip, counted for "Clear all"; D-SP-50: the visitor's chip, as StorePass's pill shows on its listings)
  function stockByVisit() {
    if (addressHasStock()) return false;
    try { const g = window.DCG.storepassGuard; return !!(g && typeof g.stockChosen === 'function' && g.stockChosen()) && !!filters().stock; } catch (_) { return false; }
  }
  const filterKey = f => [f.stock, f.gte, f.lte, (f.facets || []).map(p => p.join('=')).sort().join('&')].join('|');
  // The filters on, as this file last set them or Back / Forward left them. StorePass writes the address itself
  // when its own sort control is used, and keeps only the keys it knows: the net's filter keys are put back
  // (found on the draft by v2-10-6-browser-test.js: "Price: Low-High" took In Stock and up to $30 off).
  let held = { stock: '', gte: '', lte: '', facets: [] };
  function holdFilters() {
    const f = addressFilters();
    if (filterKey(f) === filterKey(held) || !filtersOn(held)) return;
    try {
      const url = new URL(window.location.href);
      writeFilters(url, held);
      window.history.replaceState(window.history.state, '', url.toString());
    } catch (_) {}
  }
  const filtersOn = f => (f.stock ? 1 : 0) + (f.gte || f.lte ? 1 : 0) + (f.facets ? f.facets.length : 0);
  // a price as Shopify's filter takes it: a number of dollars and cents, or nothing
  function price(text) {
    const t = String(text || '').replace(/[\s$,]/g, '').replace(/^CAD/i, '');
    if (!t) return '';
    return /^\d+(\.\d{0,2})?$/.test(t) ? String(Number(t)) : null;     // null: not a price
  }

  // ── State ──
  let active = null;                 // null, or { why: 'zero' | 'failed' | 'mismatch' | 'capped' }
  let mismatch = null;               // StorePass's count for the whole collection, when it is above the rule
  let capped = null;                 // v2-10-7: { products, count } when StorePass's answer is one page and Shopify holds more
  let host = null, note = null;      // our two nodes
  let controls = null;               // v2-10-6: the In Stock and Price controls (a third node)
  let offer = null;                  // v2-10-6: what the collection's filters offer, from the view: { stock, stockValue, gte, lte, max }
  let shown = null;                  // the page of Shopify's listing on screen: { sort, page, filters, total, first, last, pages, cards }
  let wanted = null;                 // the page being fetched, or on screen: { sort, page, filters }
  let seq = 0;                       // only the newest fetch is put on the page
  let moved = null;                  // a page was asked for here: { page, at, drawn, answered }; the new page starts where the results start
  let said = false;                  // the console line is said once a page view
  const answers = new Map();         // search key -> { products: number of cards in the page answer, count: StorePass's total, pages: its pages }
  function answer(key) {
    if (!answers.has(key)) { answers.set(key, { products: null, count: null, pages: null }); if (answers.size > 20) answers.delete(answers.keys().next().value); }
    return answers.get(key);
  }

  // ── The DCG card's own files, loaded when they are first needed ──
  // A StorePass collection page does not draw DCG cards and does not load these.
  let assets = null;             // { css: Promise, js: Promise }
  function loadScript(src) {
    return new Promise(resolve => {
      if (!src) { resolve(); return; }
      const s = document.createElement('script');
      s.src = src;
      s.async = false;
      s.onload = s.onerror = () => resolve();
      document.head.appendChild(s);
    });
  }
  function ensureAssets() {
    if (assets) return assets;
    const urls = window.DCG.fallbackAssets || {};
    // the card's stylesheets (the card's own, then its type sizes over StorePass's, in that order):
    // the cards are not shown before they are in, or 3 seconds have gone
    const sheets = [].concat(urls.css || []).filter(Boolean);
    const css = new Promise(resolve => {
      if (!sheets.length || document.querySelector('link[data-dcg-fallback-css]')) { resolve(); return; }
      let left = sheets.length;
      const one = () => { if (--left <= 0) resolve(); };
      sheets.forEach(href => {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = href;
        link.setAttribute('data-dcg-fallback-css', '');
        link.onload = link.onerror = one;
        document.head.appendChild(link);
      });
      setTimeout(resolve, 3000);
    });
    const js = Promise.resolve()
      .then(() => (typeof window.productAddToCart === 'function' ? null : loadScript(urls.bridge)))   // adds go through the cart bridge and the enforcer
      .then(() => (typeof window.dcgInitProductCards === 'function' ? null : loadScript(urls.card)));  // the card's own script
    assets = { css: css, js: js };
    return assets;
  }
  // The cards are made live by the card's own script, as on every page that draws them.
  function initCards() {
    if (!host) return;
    try {
      if (typeof window.dcgInitProductCards === 'function') window.dcgInitProductCards(host);
      document.dispatchEvent(new CustomEvent('dcg:collection:rendered'));     // the card script puts the hearts of wishlisted products back
    } catch (_) { /* a card that is not live still shows its product and links to it */ }
  }

  // ── Our nodes, kept in their places ──
  // StorePass draws its listing with React and may draw it again at any time; what is ours is put back.
  function place() {
    const c = collection();
    if (!active || !c) return;
    const root = c.root;
    if (root.getAttribute(ATTR) !== 'shopify') root.setAttribute(ATTR, 'shopify');
    if (!root.hasAttribute(PAGING_ATTR)) root.setAttribute(PAGING_ATTR, '');
    // the listing: after StorePass's (empty) results
    const section = root.querySelector('.store-pass-products-section');
    if (!host) { host = make('div', HOST, { 'data-dcg-fallback-host': '' }); setBusy(LOAD_TEXT); }
    if (section && section.parentNode) { if (section.nextElementSibling !== host) section.parentNode.insertBefore(host, section.nextSibling); }
    else if (host.parentNode !== root) root.appendChild(host);
    // the one line in the sidebar, where the filter groups were
    const groups = root.querySelector('.store-pass-side-filters .store-pass-filters');
    if (groups && groups.parentNode) {
      if (!note) { note = make('p', NOTE, { 'data-dcg-fallback-note': '' }); note.textContent = NOTE_TEXT; }
      if (groups.previousElementSibling !== note) groups.parentNode.insertBefore(note, groups);
      // V3.1.2 (item 8): the line says so only where Shopify offers this collection no filter at all
      const offersSome = !!(offer && (offer.stock || (offer.gte && offer.lte) || (offer.facets && offer.facets.length)));
      if (note.hidden !== offersSome) note.hidden = offersSome;
      // v2-10-6: In Stock and Price, above the line, once the view has said what the collection's filters offer
      if (offer) {
        if (!controls) controls = buildControls(root);
        if (controls && note.previousElementSibling !== controls) note.parentNode.insertBefore(controls, note);
      }
    }
    if (controls) syncControls(root);
    placeLines(root);
    placeChips(root);
  }

  // ── The two controls (v2-10-6) ──
  // Copies of StorePass's own "Show" and "Price Range" groups (hidden on this path with the rest of its groups),
  // so they are drawn as on the StorePass path by the same stylesheets. Nothing of StorePass's is moved or
  // changed, and no handler of StorePass's runs on them: every press on them is ours, and goes no further.
  const headWords = n => String((n.querySelector('.store-pass-collapsible-menu-header') || n).textContent || '').replace(/\s+/g, ' ').trim();
  function theirGroup(root, re) {
    const all = root.querySelectorAll('.store-pass-side-filters .store-pass-filters > *');
    for (let i = 0; i < all.length; i++) if (re.test(headWords(all[i]))) return all[i];
    return null;
  }
  // a group in StorePass's shape, where StorePass has not drawn its own (or draws it otherwise)
  function plainGroup(title) {
    const g = make('div', 'store-pass-outside-alterter');
    const head = make('div', 'store-pass-collapsible-menu-header');
    const strong = make('strong'); const span = make('span'); span.textContent = title; strong.appendChild(span); head.appendChild(strong);
    g.appendChild(head); g.appendChild(make('div', 'store-pass-collapsible-menu-content'));
    return g;
  }
  function copyOf(root, re, title) {
    const theirs = theirGroup(root, re);
    const g = theirs ? theirs.cloneNode(true) : plainGroup(title);
    // what other scripts wrote on StorePass's nodes is not copied with them
    [g].concat(Array.prototype.slice.call(g.querySelectorAll('*'))).forEach(n => {
      Array.prototype.slice.call(n.attributes).forEach(a => { if (/^data-dcg-|^id$|^aria-/.test(a.name)) n.removeAttribute(a.name); });
    });
    g.setAttribute('data-dcg-fbf-group', '');
    return g;
  }
  function buildControls(root) {
    const box = make('div', CONTROLS, { [CONTROLS_ATTR]: '' });
    // "Show": In Stock Only, a switch
    const show = copyOf(root, /^show$/i, 'Show');
    show.setAttribute('data-dcg-fbf', 'stock');
    const showBody = show.querySelector('.store-pass-collapsible-menu-content');
    let link = showBody.querySelector('a');
    while (showBody.firstChild) showBody.removeChild(showBody.firstChild);
    if (!link) link = make('a');
    link.textContent = 'In Stock Only';
    link.setAttribute('href', '#');
    link.setAttribute('role', 'switch');
    link.setAttribute('data-dcg-fbf-stock', '');
    showBody.appendChild(link);
    // "Price Range": From, To, Search
    const range = copyOf(root, /^price range$/i, 'Price Range');
    range.setAttribute('data-dcg-fbf', 'price');
    const body = range.querySelector('.store-pass-collapsible-menu-content');
    const inputs = body.querySelectorAll('input');
    if (inputs.length < 2 || !body.querySelector('button')) {
      while (body.firstChild) body.removeChild(body.firstChild);
      const wrap = make('div');
      const lab = t => { const d = make('div', 'price-label mt-2'); d.textContent = t; return d; };
      wrap.appendChild(lab('From')); wrap.appendChild(make('input', '', { type: 'text' }));
      wrap.appendChild(lab('To')); wrap.appendChild(make('input', '', { type: 'text' }));
      const b = make('button'); b.textContent = 'Search'; wrap.appendChild(b);
      body.appendChild(wrap);
    }
    const [from, to] = body.querySelectorAll('input');
    // names of our own: assets/dcg-storepass-filters.js empties StorePass's min-price / max-price boxes
    from.setAttribute('name', 'dcg-fbf-from'); from.setAttribute('placeholder', 'Min Price'); from.setAttribute('inputmode', 'decimal'); from.setAttribute('aria-label', 'Price from'); from.value = '';
    to.setAttribute('name', 'dcg-fbf-to'); to.setAttribute('placeholder', 'Max Price'); to.setAttribute('inputmode', 'decimal'); to.setAttribute('aria-label', 'Price to'); to.value = '';
    const search = body.querySelector('button');
    search.setAttribute('type', 'button');
    search.setAttribute('data-dcg-fbf-search', '');
    box.appendChild(show);
    box.appendChild(range);

    // every press here is ours (and StorePass's own listeners, on the page's root, do not hear it)
    const stop = e => { e.stopPropagation(); };
    box.addEventListener('click', e => {
      try {
        const t = e.target;
        e.stopPropagation();
        const head = t.closest && t.closest('.store-pass-collapsible-menu-header');
        if (head && box.contains(head)) { e.preventDefault(); fold(head.parentNode); return; }
        if (t.closest && t.closest('[data-dcg-fbf-stock]')) { e.preventDefault(); switchStock(); return; }
        const val = t.closest && t.closest('[data-dcg-fbf-value]');
        if (val && box.contains(val)) { e.preventDefault(); const g = val.closest('[data-dcg-fbf-facet]'); if (g) toggleFacet(g.getAttribute('data-dcg-fbf-facet'), val.getAttribute('data-dcg-fbf-value')); return; }
        if (t.closest && t.closest('[data-dcg-fbf-search]')) { e.preventDefault(); applyPrice(); }
      } catch (_) {}
    });
    box.addEventListener('keydown', e => {
      try {
        e.stopPropagation();
        if (e.key === 'Enter' && e.target && e.target.tagName === 'INPUT') { e.preventDefault(); applyPrice(); }
        if ((e.key === ' ' || e.key === 'Spacebar') && e.target && e.target.hasAttribute && e.target.hasAttribute('data-dcg-fbf-stock')) { e.preventDefault(); e.target.click(); }
        if ((e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') && e.target && e.target.classList && e.target.classList.contains('dcg-spf-head') && e.target.closest('[data-dcg-fbf-facet]')) { e.preventDefault(); e.target.click(); }
        if ((e.key === ' ' || e.key === 'Spacebar') && e.target && e.target.hasAttribute && e.target.hasAttribute('data-dcg-fbf-value')) { e.preventDefault(); e.target.click(); }
      } catch (_) {}
    });
    ['input', 'change', 'keyup', 'keypress', 'focusin', 'mousedown', 'pointerdown', 'touchstart'].forEach(n => box.addEventListener(n, stop));
    return box;
  }
  // a group opened and shut by its heading, as StorePass's are
  function fold(group) {
    const body = group.querySelector('.store-pass-collapsible-menu-content');
    if (!body) return;
    body.hidden = !body.hidden;
    const path = group.querySelector('.store-pass-collapsible-menu-header svg path');
    if (path) path.setAttribute('d', body.hidden ? PLUS : MINUS);
  }
  function applyPrice() {
    if (!controls) return;
    const [from, to] = controls.querySelectorAll('[data-dcg-fbf="price"] input');
    const gte = price(from.value), lte = price(to.value);
    from.toggleAttribute('aria-invalid', gte === null);
    to.toggleAttribute('aria-invalid', lte === null);
    if (gte === null || lte === null) return;               // not a price: nothing is asked for; the box says so
    setFilters({ gte: gte, lte: lte });
  }
  // the controls say what the address says; a control the collection has no filter for is not shown
  // V3.1.2 (item 8): a group for each of Shopify's list filters, in StorePass's sidebar skin (the panel's own classes for
  // the heading and the values, so the skin draws them as the panel's groups are drawn on StorePass's pages); the values
  // with their counts, a value Shopify counts 0 not shown unless it is on; a group of one value hidden (item 6's rule),
  // unless it is on. Drawn again only when what Shopify offers or the address changes; a group that was open stays open.
  const openFacets = new Set();
  let facetsDrawn = '';
  function drawFacets() {
    if (!controls) return;
    const f = addressFilters();
    const on = (param, value) => f.facets.some(([k, v]) => k === param && v === value);
    const list = (offer && offer.facets) || [];
    const sig = JSON.stringify([list, f.facets, Array.from(openFacets)]);
    if (sig === facetsDrawn) return;
    facetsDrawn = sig;
    Array.prototype.slice.call(controls.querySelectorAll('[data-dcg-fbf-facet]')).forEach(g => g.remove());
    list.forEach(facet => {
      const values = facet.values.filter(v => v.count > 0 || on(facet.param, v.value) || v.active);
      const chosen = values.filter(v => on(facet.param, v.value));
      if (!values.length || (values.length < 2 && !chosen.length)) return;
      const g = make('div', 'store-pass-outside-alterter dcg-spf-group', { 'data-dcg-fbf-facet': facet.param, 'data-dcg-fbf-group': '' });
      const open = openFacets.has(facet.param) || chosen.length > 0;
      const head = make('div', 'store-pass-collapsible-menu-header dcg-spf-head', { role: 'button', tabindex: '0', 'aria-expanded': open ? 'true' : 'false' });
      const strong = make('strong'), span = make('span'); span.textContent = facet.label; strong.appendChild(span); head.appendChild(strong);
      const pick = make('span', 'dcg-spf-chosen'); pick.textContent = chosen.map(v => v.label).join(', '); head.appendChild(pick);
      head.insertAdjacentHTML('beforeend', '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M19,13H5V11H19V13Z"></path><path class="dcg-spf-upright" d="M13,5V19H11V5H13Z"></path></svg>');
      const body = make('div', 'store-pass-collapsible-menu-content dcg-spf-body');
      body.hidden = !open;
      const ul = make('ul', 'store-pass-filter-list dcg-spf-list');
      values.forEach(v => {
        const li = make('li');
        const a = make('a', 'dcg-spf-item', { href: '#', 'data-dcg-fbf-value': v.value, role: 'checkbox', 'aria-checked': on(facet.param, v.value) ? 'true' : 'false' });
        if (on(facet.param, v.value)) a.setAttribute('aria-current', 'true');
        a.appendChild(document.createTextNode(v.label));
        const n = make('span', 'dcg-fbf-count'); n.textContent = fmt(v.count); a.appendChild(n);
        li.appendChild(a); ul.appendChild(li);
      });
      body.appendChild(ul);
      g.appendChild(head); g.appendChild(body);
      head.addEventListener('click', e => { e.preventDefault(); e.stopPropagation(); const willOpen = body.hidden; body.hidden = !willOpen; head.setAttribute('aria-expanded', willOpen ? 'true' : 'false'); if (willOpen) openFacets.add(facet.param); else openFacets.delete(facet.param); facetsDrawn = ''; });
      controls.appendChild(g);
    });
  }
  // V3.1.2 (item 8): a chip for each filter that is on (a value of Shopify's filters, the price range; In Stock Only
  // when the address carries it), drawn as StorePass's pills over the results, its x taking that filter off
  let chipsDrawn = '';
  function placeChips(root) {
    if (!active || !root) return;
    const f = addressFilters();
    const labelOf = (param, value) => { const facet = ((offer && offer.facets) || []).find(x => x.param === param); const v = facet && facet.values.find(x => x.value === value); return (facet ? facet.label + ': ' : '') + (v ? v.label : value); };
    const chips = [];
    f.facets.forEach(([k, v]) => chips.push({ key: k, value: v, text: labelOf(k, v) }));
    if (f.gte || f.lte) chips.push({ key: 'price', text: 'Price: ' + (f.gte ? '$' + f.gte : 'up') + (f.lte ? ' to $' + f.lte : ' and over') });
    if ((f.stock && addressHasStock()) || stockByVisit()) chips.push({ key: 'stock', text: 'In Stock Only' });   // (the addendum's gate) and the visit's
    const after = root.querySelector('.store-pass-products-section') ? root.querySelector('.store-pass-products-section').parentNode.querySelector(':scope > .store-pass-active-filters') : null;
    let box = root.querySelector('[data-dcg-fbf-chips]');
    if (!box) { box = make('div', 'dcg-fbf-chips', { 'data-dcg-fbf-chips': '', role: 'group', 'aria-label': 'Filters on' }); }
    if (after && after.nextElementSibling !== box) after.parentNode.insertBefore(box, after.nextSibling);
    else if (!after && box.parentNode !== host.parentNode && host.parentNode) host.parentNode.insertBefore(box, host);
    const sig = JSON.stringify(chips);
    if (sig === chipsDrawn && box.childNodes.length === chips.length) return;
    chipsDrawn = sig;
    while (box.firstChild) box.removeChild(box.firstChild);
    box.hidden = !chips.length;
    chips.forEach(ch => {
      const b = make('button', 'dcg-fbf-chip', { type: 'button', 'aria-label': 'Take off ' + ch.text });
      const t = make('span'); t.textContent = ch.text; b.appendChild(t);
      b.insertAdjacentHTML('beforeend', '<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true" focusable="false"><path fill="currentColor" d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"></path></svg>');
      b.addEventListener('click', e => {
        e.preventDefault(); e.stopPropagation();
        if (ch.key === 'price') setFilters({ gte: '', lte: '' });
        // (the addendum's gate) off as the switch turns it off: the visit's "on" is let go too, or filters() would read it
        // again for the address without its key, and the listing stayed in stock with the chip gone
        else if (ch.key === 'stock') { if (filters().stock) switchStock(); else setFilters({ stock: '' }); }
        else toggleFacet(ch.key, ch.value);
      });
      box.appendChild(b);
    });
  }
  function syncControls(root) {
    drawFacets();
    const f = filters();
    const stockGroup = controls.querySelector('[data-dcg-fbf="stock"]'), priceGroup = controls.querySelector('[data-dcg-fbf="price"]');
    const hasStock = !!(offer && offer.stock), hasPrice = !!(offer && offer.gte && offer.lte);
    if (stockGroup.hidden !== !hasStock) stockGroup.hidden = !hasStock;
    if (priceGroup.hidden !== !hasPrice) priceGroup.hidden = !hasPrice;
    if (controls.hidden !== !(hasStock || hasPrice)) controls.hidden = !(hasStock || hasPrice);
    root.setAttribute(CONTROLS_ATTR, !offer ? '' : hasStock && hasPrice ? 'both' : hasStock ? 'stock' : hasPrice ? 'price' : 'none');
    const link = controls.querySelector('[data-dcg-fbf-stock]');
    const on = !!f.stock;
    if (link.getAttribute('data-dcg-spf-toggle') !== (on ? 'on' : 'off')) link.setAttribute('data-dcg-spf-toggle', on ? 'on' : 'off');
    if (link.getAttribute('aria-checked') !== String(on)) link.setAttribute('aria-checked', String(on));
    const [from, to] = priceGroup.querySelectorAll('input');
    const ph = offer && offer.max ? offer.max : 'Max Price';
    if (to.getAttribute('placeholder') !== ph) to.setAttribute('placeholder', ph);
    // the boxes follow the address, except while the customer is typing in one
    if (document.activeElement !== from && from.value !== f.gte && price(from.value) !== f.gte) from.value = f.gte;
    if (document.activeElement !== to && to.value !== f.lte && price(to.value) !== f.lte) to.value = f.lte;
    // "Clear all" in the panel heading: assets/dcg-storepass-filters.js keeps it, and asks this file; without that
    // script, this file puts one there itself
    const headRow = root.querySelector('.store-pass-side-filters .store-pass-filter > div:first-child');
    if (headRow && !headRow.querySelector('.dcg-spf-clear')) {
      const clear = make('button', 'dcg-spf-clear', { type: 'button', 'data-dcg-fallback-clear': '' });
      clear.textContent = 'Clear all';
      clear.addEventListener('click', e => { e.preventDefault(); e.stopPropagation(); clearFilters(); });
      const title = headRow.querySelector('strong');
      headRow.insertBefore(clear, title ? title.nextSibling : headRow.firstChild);
    }
    const mineClear = headRow && headRow.querySelector('.dcg-spf-clear[data-dcg-fallback-clear]');
    const fa = addressFilters();                     // V3.1.2 (item 1): the default In Stock Only is not a filter on
    const count = filtersOn(fa) + (stockByVisit() ? 1 : 0);   // (the addendum's gate) the visit's is
    if (mineClear && mineClear.hidden !== !count) mineClear.hidden = !count;
  }
  // A filter changed here: into the address (a new step for Back, as a filter on the StorePass path is), back
  // to page 1, and that listing asked for. StorePass is told only when the page changes (it keeps the page).
  // V3.1.2 (item 1): `again`: the listing is asked for even when the address does not change (the default changed).
  let refiltered = false;
  function setFilters(next, again) {
    if (!active) return;
    const f = Object.assign(addressFilters(), next);           // the default In Stock Only is never written into the address
    const url = new URL(window.location.href);
    const was = url.searchParams.get('page');
    writeFilters(url, f);                                       // V3.1.2 (item 8): the facets too
    ['page', 'skip', 'shopify_page_parameters'].forEach(k => url.searchParams.delete(k));
    const same = url.toString() === window.location.href;
    // (the addendum's gate) and when the filters in force are not those of the listing on screen or on its way: the
    // visit's In Stock Only let go leaves the address as it was, not the listing
    if (same && !again && !(wanted && filterKey(filters()) !== wanted.filters)) { syncControls(listing()); return; }
    refiltered = true;
    held = { stock: url.searchParams.get(KEYS.stock) || '', gte: url.searchParams.get(KEYS.gte) || '', lte: url.searchParams.get(KEYS.lte) || '', facets: (f.facets || []).slice() };
    try {
      if (!same) window.history.pushState({ dcgFallback: 1 }, '', url.toString());
      if (!same && was && was !== '1' && typeof window.onpopstate === 'function') window.dispatchEvent(new PopStateEvent('popstate', { state: { dcgFallback: 1 } }));
    } catch (_) { window.location.assign(url.toString()); return; }
    const sort = (shown && shown.sort) || (wanted && wanted.sort) || openingBy();
    show(sort, 1);
    const root = listing();
    if (root && controls) syncControls(root);
  }
  // (the addendum's gate, 21 OCT) "Clear all" puts the site's default back: the visit's In Stock Only choice is forgotten
  // first (the guard's), or filters() would read the visit's "on" again for an address with no key and keep it on
  function clearFilters() {
    stockDropped = false;
    try { const g = window.DCG.storepassGuard; if (g && typeof g.forgetStock === 'function') g.forgetStock(); } catch (_) {}
    setFilters({ stock: '', gte: '', lte: '', facets: [] });
  }
  // V3.1.2 (item 8): a value of one of Shopify's filters, on or off (a filter can have several values on: Shopify
  // reads them as one or the other)
  function toggleFacet(param, value) {
    const f = addressFilters();
    const i = f.facets.findIndex(([k, v]) => k === param && v === value);
    if (i === -1) f.facets.push([param, value]); else f.facets.splice(i, 1);
    setFilters({ facets: f.facets });
  }
  // V3.1.2 (item 1): the switch. Where In Stock Only is on by default (the settings file's, through the guard), the
  // visitor's choice, remembered for the visit as on StorePass's path; the address keeps no key for it (one it had
  // came from a link, and goes); the listing is asked for again. Where it is not, as before (v2-10-6): the address
  // carries filter.v.availability=1 while it is on.
  // V3.1.2, the addendum (Cole, 21 OCT): In Stock Only is off by default again, and the visitor's choice is still kept
  // for the visit: the switch tells the guard whatever the file's default (on: kept "on"; off: nothing kept), so the
  // visit's next listings, StorePass's or the net's, open as the visitor left it; and with the default off the address
  // carries it while it is on (v2-10-6: a filter the visitor added, linkable, "Clear all" shows)
  function switchStock() {
    if (!active) return;
    const on = !filters().stock;
    stockDropped = false;
    let g = null;
    try { g = window.DCG.storepassGuard; } catch (_) { g = null; }
    const remembers = !!(g && typeof g.stockState === 'function' && typeof g.rememberStock === 'function');
    const byDefault = remembers && g.stockState().file === true;
    if (remembers && !byDefault) { try { g.rememberStock(on); } catch (_) {} }
    if (byDefault) {
      try { g.rememberStock(on); } catch (_) {}
      // (an address's in_stock held it for this page: the press is the visitor's choice now, so the hold goes)
      try { const u = new URL(window.location.href); if (u.searchParams.has('in_stock')) { u.searchParams.delete('in_stock'); window.history.replaceState(window.history.state, '', u.pathname + u.search + u.hash); } } catch (_) {}
      setFilters({ stock: '' }, true);
      return;
    }
    setFilters({ stock: on ? ((offer && offer.stockValue) || '1') : '' });
  }
  // "Showing 1-60 of 324" in the results bar and at the head of the phone filter drawer, before StorePass's own count
  // (the places assets/dcg-storepass-paging.js uses). Under the results it is in the listing itself.
  function lineText() {
    if (!shown || !shown.cards) return '';
    return 'Showing ' + fmt(shown.first) + '-' + fmt(shown.last) + (shown.total > SHOPIFY_COUNTS_TO ? '' : ' of ' + fmt(shown.total)) +
      (typeof shown.inStock === 'number' && shown.inStock <= shown.total ? ' · ' + fmt(shown.inStock) + ' in stock' : '');   // the addendum
  }
  function placeLines(root) {
    const text = lineText();
    const ours = Array.prototype.slice.call(root.querySelectorAll('.' + LINE + '[' + MINE + ']'));
    if (!text) { ours.forEach(n => n.remove()); return; }
    const theirs = root.querySelectorAll('.store-pass-results-count');
    for (let i = 0; i < theirs.length; i++) {
      const parent = theirs[i].parentNode;
      if (!parent || !parent.closest) continue;
      const inBar = !!parent.closest('.store-pass-results-header');
      if (!inBar && !parent.closest('.store-pass-side-filters')) continue;
      let line = theirs[i].previousElementSibling;
      if (!line || !line.hasAttribute || !line.hasAttribute(MINE)) {
        line = make('div', LINE, inBar ? { role: 'status', 'aria-live': 'polite', tabindex: '-1' } : {});
        line.setAttribute(MINE, '');
        parent.insertBefore(line, theirs[i]);
      }
      if (line.textContent !== text) line.textContent = text;
    }
    const bar = root.querySelector('.store-pass-results-header');
    if (bar && !bar.querySelector('.' + LINE + '[' + MINE + ']')) {
      const line = make('div', LINE, { role: 'status', 'aria-live': 'polite', tabindex: '-1' });
      line.setAttribute(MINE, '');
      line.textContent = text;
      bar.insertBefore(line, bar.firstChild);
    }
  }

  // ── The listing ──
  function setBusy(text) {
    if (!host) return;
    if (host.querySelector('[data-dcg-fallback-grid]')) { host.setAttribute('aria-busy', 'true'); return; }   // a page is on screen: it stays, dimmed, until the next one comes
    while (host.firstChild) host.removeChild(host.firstChild);
    const p = make('p', HOST + '__status', { role: 'status' });
    p.textContent = text;
    host.appendChild(p);
  }
  // the addendum: `view` the whole view (VIEW: no page) or the paged one; `stock` the availability asked for in place of
  // the visitor's (the two parts of a stitched page: '1' and '0')
  function viewUrl(c, sort, page, f, view, stock) {
    const base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const q = new URLSearchParams();
    q.set('view', view || VIEW);
    if (page > 1) q.set('page', String(page));
    q.set('sort_by', sort);
    // v2-10-6: Shopify's storefront filters, which Shopify applies to the listing (the theme filters nothing)
    const s = stock !== undefined ? stock : f && f.stock;
    if (s) q.set(KEYS.stock, s);
    if (f && f.gte) q.set(KEYS.gte, f.gte);
    if (f && f.lte) q.set(KEYS.lte, f.lte);
    (f && f.facets ? f.facets : []).forEach(([k, v]) => q.append(k, v));      // V3.1.2 (item 8)
    return base + 'collections/' + encodeURIComponent(c.handle) + '?' + q.toString();
  }
  // The address of page <n> as this page's own address has it.
  function hrefFor(page) {
    const url = new URL(window.location.href);
    ['skip', 'shopify_page_parameters'].forEach(k => url.searchParams.delete(k));
    if (page > 1) url.searchParams.set('page', String(page)); else url.searchParams.delete('page');
    return url;
  }
  // V3.1.2 (item 8): the view's block of Shopify's list filters: [{ param, label, values: [{ value, label, count, active }] }]
  // the addendum (D-SP-49, decided by Cole): Shopify's Tags facet (filter.p.tag) shows the tag groups the settings file
  // names, as StorePass's Tag group does (the guard's §L: a tag's group is its word before "_"; a value on in the address
  // stays shown, so it can be taken off)
  function tagShown(value, active) {
    if (active) return true;
    try { const g = window.DCG.storepassGuard; if (g && typeof g.tagShown === 'function') return g.tagShown(value); } catch (_) {}
    return true;
  }
  function readFacets(block) {
    if (!block) return [];
    return Array.prototype.slice.call(block.querySelectorAll('[data-facet]')).map(d => ({
      param: d.getAttribute('data-param') || '', label: d.getAttribute('data-label') || '',
      values: Array.prototype.slice.call(d.querySelectorAll('[data-value]')).map(v => ({ value: v.getAttribute('data-value') || '', label: (v.textContent || '').trim(), count: parseInt(v.getAttribute('data-count'), 10) || 0, active: v.getAttribute('data-active') === 'true' }))
    })).map(x => (x.param === 'filter.p.tag' ? Object.assign(x, { values: x.values.filter(v => tagShown(v.value, v.active)) }) : x)).filter(x => x.param && x.values.length);
  }
  function put(view) {
    if (!host) return;
    const facetBlock = view.querySelector('[data-dcg-fallback-facets]');
    const facets = readFacets(facetBlock);
    if (facetBlock) facetBlock.parentNode.removeChild(facetBlock);
    const num = k => { const n = parseInt(view.getAttribute(k), 10); return n >= 0 ? n : 0; };
    while (host.firstChild) host.removeChild(host.firstChild);
    host.removeAttribute('aria-busy');
    Array.prototype.slice.call(view.childNodes).forEach(n => host.appendChild(document.importNode(n, true)));
    shown = { sort: wanted ? wanted.sort : openingBy(), page: num('data-page') || 1, filters: wanted ? wanted.filters : '||', total: num('data-total'), first: num('data-first'), last: num('data-last'), pages: num('data-pages'), cards: num('data-cards') };
    // the addendum: the in-stock part, for the count line ("· 278 in stock"), where the view says it and In Stock Only is off
    const stockSaid = view.getAttribute('data-instock');
    shown.inStock = stockSaid === null || stockSaid === '' || String(shown.filters).split('|')[0] ? null : num('data-instock');
    shown.mode = view.getAttribute('data-mode') || 'paged';
    host.setAttribute('data-dcg-fallback-page', String(shown.page));
    host.setAttribute('data-dcg-fallback-total', String(shown.total));
    host.setAttribute('data-dcg-fallback-sort', shown.sort);
    host.setAttribute('data-dcg-fallback-filter', shown.filters);
    // v2-10-6: what the collection's filters offer (the view writes it from collection.filters)
    const word = k => String(view.getAttribute(k) || '');
    offer = { filters: num('data-filters'), stock: word('data-stock-param'), stockValue: word('data-stock-value') || '1', gte: word('data-price-gte'), lte: word('data-price-lte'), max: word('data-price-max'), facets: facets };
    // the count as the count line of the other pages writes it, and the pager's links as this page's own addresses
    const foot = host.querySelector('[data-dcg-fallback-count]');
    if (foot && lineText()) foot.textContent = lineText();
    host.querySelectorAll('a[data-dcg-page]').forEach(a => { const n = parseInt(a.getAttribute('data-dcg-page'), 10); if (n >= 1) a.setAttribute('href', hrefFor(n).toString()); });
    place();
    ensureAssets().js.then(initCards);
    if (moved) { moved.drawn = true; land(); }
    // v2-10-6: after a filter changed here, a page scrolled down past the start of the results is brought back to it
    if (refiltered) {
      refiltered = false;
      try {
        const bar = (listing() && listing().querySelector('.store-pass-results-header')) || host;
        if (bar.getBoundingClientRect().top < 0) bar.scrollIntoView({ block: 'start', behavior: reduceMotion() ? 'instant' : 'smooth' });
      } catch (_) {}
    }
    try { document.dispatchEvent(new CustomEvent('dcg:collection-fallback', { detail: Object.assign({ why: active ? active.why : null }, shown) })); } catch (_) {}
  }
  // After a page change made here, the results are brought to where they start, under whatever header is on
  // screen, and the count line takes the focus (as assets/dcg-storepass-paging.js does for StorePass's results).
  // Not before StorePass's own search for that page has answered: when its answer comes StorePass puts the page
  // at its very top, which would undo it (seen on the draft: the bar landed, then the page went to the top).
  // If StorePass does not answer, 3 seconds are enough of a wait.
  const LAND_AFTER_ANSWER = 350, LAND_PATIENCE = 3000;
  function land() {
    if (!moved || !moved.drawn || !active) return;
    const waited = Date.now() - moved.at;
    if (!moved.answered && waited < LAND_PATIENCE) { setTimeout(land, 250); return; }
    if (moved.answered && Date.now() - moved.answered < LAND_AFTER_ANSWER) { setTimeout(land, LAND_AFTER_ANSWER - (Date.now() - moved.answered) + 10); return; }
    moved = null;
    try {
      const root = listing();
      const bar = (root && root.querySelector('.store-pass-results-header')) || host;
      const line = bar.querySelector('.' + LINE + '[' + MINE + ']');
      // v2-10-8 (item 1): on the count line, by the paging script's landing (one jump, held while the page settles)
      const paging = window.DCG.storepassPaging;
      if (paging && typeof paging.land === 'function') { paging.land(line || bar); return; }
      bar.scrollIntoView({ block: 'start', behavior: reduceMotion() ? 'instant' : 'smooth' });
      if (line && typeof line.focus === 'function') line.focus({ preventScroll: true });
    } catch (_) {}
  }
  // StorePass's search for the page that was asked for here has answered, or failed
  function heard(query) {
    if (moved && !moved.answered && pageOf(query) === moved.page) { moved.answered = Date.now(); if (moved.drawn) land(); }
  }

  // ── The page of the listing (V3.1.2, the addendum: in stock first) ──
  // Each view asked for once (2 minutes): the whole collection's serves every one of its pages
  const views = new Map();               // url -> { at, promise of the view's element }
  function getView(url) {
    const had = views.get(url);
    if (had && Date.now() - had.at < 120000) return had.promise;
    let request;
    try { request = window.fetch(url, { credentials: 'same-origin', headers: { Accept: 'text/html' } }); }
    catch (e) { request = Promise.reject(e); }
    const promise = request.then(r => { if (!r.ok) throw new Error('view ' + r.status); return r.text(); }).then(html => {
      const view = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-dcg-fallback-view]');
      if (!view) throw new Error('no view');
      return view;
    });
    const entry = { at: Date.now(), promise: promise };
    views.set(url, entry);
    while (views.size > 12) views.delete(views.keys().next().value);
    promise.catch(() => { if (views.get(url) === entry) views.delete(url); });
    return promise;
  }
  const numOf = (el, k) => { const n = parseInt(el.getAttribute(k), 10); return n >= 0 ? n : 0; };
  const cardsOf = view => Array.prototype.slice.call(view.querySelectorAll('[data-dcg-fallback-grid] > .dcg-fallback__item'));
  // the count line and the pager under the cards, in the markup the section writes for its paged view
  const ARROWS = { prev: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 6l-6 6 6 6"></path></svg>', next: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"></path></svg>' };
  function footOf(w) {
    const foot = make('div', 'dcg-paging-foot dcg-fallback__foot');
    const line = make('div', 'dcg-count dcg-count--foot', { 'data-dcg-fallback-count': '' });
    line.textContent = 'Showing ' + w.first + '-' + w.last + ' of ' + w.total;
    foot.appendChild(line);
    if (w.pages <= 1) return foot;
    const nav = make('nav', 'dcg-pager', { 'aria-label': 'Pages of results' });
    const ul = make('ul', 'dcg-pager__list');
    const step = (kind, n, on) => {
      const li = make('li', 'dcg-pager__item dcg-pager__item--step');
      const label = kind === 'prev' ? 'Previous page' : 'Next page';
      const node = on ? make('a', 'dcg-pager__step', { href: hrefFor(n).toString(), 'aria-label': label, 'data-dcg-page': String(n), rel: kind }) : make('span', 'dcg-pager__step', { 'aria-label': label, 'aria-disabled': 'true' });
      const word = '<span class="dcg-pager__word">' + (kind === 'prev' ? 'Previous' : 'Next') + '</span>';
      node.innerHTML = kind === 'prev' ? ARROWS.prev + word : word + ARROWS.next;
      li.appendChild(node);
      return li;
    };
    ul.appendChild(step('prev', w.page - 1, w.page > 1));
    let before = 0;
    for (let n = 1; n <= w.pages; n++) {
      if (!(n === 1 || n === w.pages || Math.abs(n - w.page) <= 1)) continue;
      if (before > 0 && n - before > 1) { const gap = make('li', 'dcg-pager__item dcg-pager__item--gap', { 'aria-hidden': 'true' }); gap.textContent = '…'; ul.appendChild(gap); }
      const li = make('li', 'dcg-pager__item');
      const node = n === w.page ? make('span', 'dcg-pager__page', { 'aria-current': 'page', 'aria-label': 'Page ' + n + ' of ' + w.pages })
        : make('a', 'dcg-pager__page', { href: hrefFor(n).toString(), 'data-dcg-page': String(n), 'aria-label': (n === 1 ? 'First page, page ' : n === w.pages ? 'Last page, page ' : 'Page ') + n });
      node.textContent = String(n);
      li.appendChild(node);
      ul.appendChild(li);
      before = n;
    }
    ul.appendChild(make('li', 'dcg-pager__break', { 'aria-hidden': 'true' }));
    ul.appendChild(step('next', w.page + 1, w.page < w.pages));
    nav.appendChild(ul);
    foot.appendChild(nav);
    return foot;
  }
  // a view as the section writes one, for a page cut or stitched here: the base view's facts and filter block, these cards
  function assemble(base, cards, page, total, inStock) {
    const v = document.createElement('div');
    Array.prototype.forEach.call(base.attributes, a => v.setAttribute(a.name, a.value));
    const pages = Math.max(1, Math.ceil(total / NET_SIZE));
    const first = cards.length ? (page - 1) * NET_SIZE + 1 : 0, last = cards.length ? first + cards.length - 1 : 0;
    [['data-total', total], ['data-page', page], ['data-pages', pages], ['data-size', NET_SIZE], ['data-first', first], ['data-last', last], ['data-cards', cards.length], ['data-instock', inStock === null ? '' : inStock]].forEach(([k, n]) => v.setAttribute(k, String(n)));
    const facets = base.querySelector('[data-dcg-fallback-facets]');
    if (facets) v.appendChild(facets.cloneNode(true));
    if (cards.length) {
      const grid = make('div', 'dcg-fallback__grid dcg-collection', { 'data-dcg-fallback-grid': '' });
      cards.forEach(card => grid.appendChild(card.cloneNode(true)));
      v.appendChild(grid);
      v.appendChild(footOf({ page: page, pages: pages, first: first, last: last, total: total }));
    } else {
      const p = make('p', 'dcg-fallback__status', { 'data-dcg-fallback-none': '' });
      p.textContent = 'No results found';
      v.appendChild(p);
    }
    return v;
  }
  // the two parts' filter counts added up (each of Shopify's counts is its part's), the in-stock view's facts otherwise
  function mergedBase(inV, outV) {
    const base = inV.cloneNode(true);
    const block = base.querySelector('[data-dcg-fallback-facets]'), other = outV.querySelector('[data-dcg-fallback-facets]');
    if (block && other) {
      other.querySelectorAll('[data-facet]').forEach(f2 => {
        const param = f2.getAttribute('data-param');
        let f1 = Array.prototype.find.call(block.querySelectorAll('[data-facet]'), x => x.getAttribute('data-param') === param);
        if (!f1) { block.appendChild(f2.cloneNode(true)); return; }
        f2.querySelectorAll('[data-value]').forEach(v2 => {
          const v1 = Array.prototype.find.call(f1.querySelectorAll('[data-value]'), x => x.getAttribute('data-value') === v2.getAttribute('data-value'));
          if (!v1) { f1.appendChild(v2.cloneNode(true)); return; }
          v1.setAttribute('data-count', String(numOf(v1, 'data-count') + numOf(v2, 'data-count')));
        });
      });
    }
    // the higher of the two parts' highest prices, as the section writes it ("94.20")
    if ((parseFloat(outV.getAttribute('data-price-max')) || 0) > (parseFloat(inV.getAttribute('data-price-max')) || 0)) base.setAttribute('data-price-max', outV.getAttribute('data-price-max'));
    return base;
  }
  let splitOk = null;                    // over 250: whether Shopify's availability filter is offered (null: not known yet)
  // The page asked for, in stock first: the whole collection cut here (250 or fewer); Shopify's two listings stitched
  // (over 250, its availability filter offered, no In Stock Only on, the collection's kind asking for it); else
  // Shopify's own page
  function pageFor(c, sort, page, f) {
    if (c.count > 0 && c.count <= WHOLE_MOST) {
      return getView(viewUrl(c, sort, 0, f, VIEW)).then(base => {
        const all = cardsOf(base);
        const inStock = f.stock ? null : (base.getAttribute('data-instock') === '' ? null : numOf(base, 'data-instock'));
        return assemble(base, all.slice((page - 1) * NET_SIZE, page * NET_SIZE), page, all.length, inStock);
      });
    }
    if (grouped(c, sort) && !f.stock && splitOk !== false) {
      return stitched(c, sort, page, f).catch(err => {
        if (!err || err.message !== 'no availability filter') throw err;
        splitOk = false;
        return shopifyPage(c, sort, page, f);
      });
    }
    return shopifyPage(c, sort, page, f);
  }
  function shopifyPage(c, sort, page, f) {
    return getView(viewUrl(c, sort, page, f, VIEW_PAGED)).then(base => {
      const v = base.cloneNode(true);
      if (f.stock) v.setAttribute('data-instock', '');        // In Stock Only on: the listing is its in-stock part alone
      return v;
    });
  }
  async function stitched(c, sort, page, f) {
    const S = NET_SIZE;
    const inV = await getView(viewUrl(c, sort, page, f, VIEW_PAGED, '1'));
    if (!inV.getAttribute('data-stock-param')) throw new Error('no availability filter');
    splitOk = true;
    const K = numOf(inV, 'data-total'), inCards = cardsOf(inV);
    // inside the in-stock part: that page of it; at the seam: its tail, then the rest's head; after: the rest at its offset
    const inside = page * S <= K, seam = !inside && (page - 1) * S < K;
    const from = inside ? 0 : seam ? 0 : (page - 1) * S - K;
    const need = inside ? 0 : seam ? S - inCards.length : S;
    const q1 = Math.floor(from / S) + 1, q2 = need > 0 ? Math.floor((from + need - 1) / S) + 1 : q1;
    const outs = [];
    for (let q = q1; q <= q2; q++) outs.push(getView(viewUrl(c, sort, q, f, VIEW_PAGED, '0')));
    const outViews = await Promise.all(outs);
    const M = numOf(outViews[0], 'data-total');
    let cards = inside ? inCards : seam ? inCards.slice() : [];
    if (need > 0) {
      const pool = [].concat(...outViews.map(cardsOf));
      const off = from - (q1 - 1) * S;
      cards = cards.concat(pool.slice(off, off + need));
    }
    return assemble(mergedBase(inV, outViews[0]), cards, page, K + M, K);
  }

  function show(sort, page) {
    const c = collection();
    if (!active || !c || !opening) return;   // (the opening sort is read first: activate() shows the first page)
    const f = filters(), fk = filterKey(f);
    if (wanted && wanted.sort === sort && wanted.page === page && wanted.filters === fk) return;      // on screen, or on its way
    wanted = { sort: sort, page: page, filters: fk };
    const n = ++seq;
    place();
    setBusy(LOAD_TEXT);
    const ready = ensureAssets().css;
    pageFor(c, sort, page, f).then(view => ready.then(() => view)).then(view => {
      if (n !== seq || !active) return;
      // V3.1.2 (item 1): the default's in-stock listing is empty (nothing of the collection is in stock with Shopify
      // either): the collection is shown without it, the switch reading off; a filter the address carries stands
      if (f.stock && !addressHasStock() && !stockDropped && (parseInt(view.getAttribute('data-total'), 10) || 0) === 0) { stockDropped = true; wanted = null; show(sort, page); return; }
      put(view);
    }).catch(() => {
      if (n !== seq || !active || !host) return;
      wanted = null;                 // a later search may try again
      shown = null;
      while (host.firstChild) host.removeChild(host.firstChild);
      host.removeAttribute('aria-busy');
      const p = make('p', HOST + '__status', { role: 'alert' });
      p.textContent = FAIL_TEXT;
      host.appendChild(p);
      const root = listing();
      if (root) placeLines(root);
    });
  }

  function activate(why, query) {
    const c = collection();
    if (!c || !(c.count > 0)) return;        // (c) Liquid says the collection is empty too: "No results found", as before
    if (!active) {
      active = { why: why };
      held = addressFilters();                // a shared link's filters
      c.root.setAttribute(WHY_ATTR, why);
      if (!said) {
        said = true;
        const what = why === 'failed' ? 'failed' : why === 'mismatch' ? 'counts ' + fmt(mismatch) + ' where Shopify has ' + fmt(c.count) + ' (more than ' + fmt(limitOf(c)) + ')'
          : why === 'capped' && capped ? 'gives one page of ' + fmt(capped.products) + ' and counts ' + fmt(capped.count) + ' where Shopify has ' + fmt(c.count) + (capped.paging ? ', and its paging is broken (' + capped.paging + ')' : '') : 'returned 0';
        try { console.info('DCG: collection ' + c.handle + ' shown from Shopify (' + why + '); StorePass ' + what); } catch (_) {}
      }
      // v2-10-6 (mismatch): StorePass has drawn its cards, and the paging script its count line and pager for them;
      // those are not this collection's. Its cards are hidden by [data-dcg-fallback]; the line and the pager go.
      c.root.querySelectorAll('.dcg-paging-foot, .' + LINE).forEach(n => { if (!n.hasAttribute(MINE) && !(host && host.contains(n))) n.remove(); });
    }
    place();
    const sort = query && query.sort;
    const y = window.pageYOffset || 0;        // where the page is now: StorePass may put it at its top before the sort is read
    readOpening(c, query).then(() => {
      if (!active) return;
      show(sortOf(query), pageOf(query));
      if (!chosen()) openOn(sort, y);
    });
  }
  // The opening sort into the address and StorePass's control, where StorePass is not already on it (see THE
  // OPENING SORT above; v2-10-5, the collection's own in v2-10-6). StorePass, told of the address, searches again
  // and puts the page at its top when it does (the pager's fault of v2-10-4); a customer who had scrolled before
  // the net opened (an outage takes 8 seconds to be known) is put back where they were.
  let hold = null;                   // { y, until }: where the page was when StorePass was told
  function openOn(theirs, y) {
    const name = (opening || SALES).name;
    if (String(theirs || '') === name) return;        // StorePass opened the collection on it: its control says so already
    try {
      const url = new URL(window.location.href);
      url.searchParams.set('sort', name);
      window.history.replaceState(Object.assign({}, window.history.state || {}, { dcgFallback: 1 }), '', url.toString());
      if (!(y >= 0)) y = window.pageYOffset || 0;
      hold = y > 0 ? { y: y, until: Date.now() + LAND_PATIENCE + 1000 } : null;
      if (typeof window.onpopstate === 'function') window.dispatchEvent(new PopStateEvent('popstate', { state: { dcgFallback: 1 } }));
      keep();
    } catch (_) { /* the listing is on its opening sort all the same; only the control may read StorePass's own */ }
  }
  function keep() {
    if (!hold) return;
    if (Date.now() > hold.until) { hold = null; return; }
    if (Math.abs((window.pageYOffset || 0) - hold.y) > 2) { try { window.scrollTo(0, hold.y); } catch (_) {} }
  }
  function kept(answered) {
    if (!hold) return;
    keep();
    if (answered) setTimeout(() => { keep(); hold = null; }, LAND_AFTER_ANSWER);
  }
  function deactivate() {
    if (!active) return;
    try { const cb = document.querySelector('[data-dcg-fbf-chips]'); if (cb) cb.remove(); } catch (_) {}
    chipsDrawn = ''; facetsDrawn = '';
    active = null; shown = null; wanted = null; moved = null; hold = null; mismatch = null; capped = null; refiltered = false; held = { stock: '', gte: '', lte: '', facets: [] }; seq++;
    const root = listing();
    if (host && host.parentNode) host.parentNode.removeChild(host);
    if (note && note.parentNode) note.parentNode.removeChild(note);
    if (controls && controls.parentNode) controls.parentNode.removeChild(controls);
    host = null; note = null; controls = null;
    if (root) {
      root.querySelectorAll('.' + LINE + '[' + MINE + '], .dcg-spf-clear[data-dcg-fallback-clear]').forEach(n => n.remove());
      root.removeAttribute(ATTR);
      root.removeAttribute(WHY_ATTR);
      root.removeAttribute(CONTROLS_ATTR);
      root.removeAttribute(PAGING_ATTR);     // assets/dcg-storepass-paging.js sets it again when it has a line of its own
    }
  }

  // ── What StorePass's searches say ──
  function onStart(detail) {
    const c = collection();
    if (!c || !detail || !detail.query || !mine(detail.query, c)) return;
    // A name or a filter: StorePass's own results, whatever they are. Only the listing sends a count request
    // beside its page of products (the header's suggestions ask for products alone), so only a count request
    // says the listing itself is searching for something narrower.
    if (!plain(detail.query)) { if (detail.isCount) deactivate(); return; }
    if (active) {
      // v2-10-8 (item 1): a sort the visitor chose (StorePass's sort menu) lands on the count line, as a page does
      const paging = window.DCG.storepassPaging, asked = paging && typeof paging.sortAskedAt === 'function' ? paging.sortAskedAt() : 0;
      if (!detail.isCount && !moved && shown && asked && Date.now() - asked < 8000 && sortOf(detail.query) !== shown.sort) moved = { page: pageOf(detail.query), at: Date.now(), drawn: false, answered: 0 };
      kept(false); holdFilters(); show(sortOf(detail.query), pageOf(detail.query));     // the sort or the page changed: follow at once, the filters kept
    }
  }
  function onAnswer(detail) {
    const c = collection();
    if (!c || !detail || !detail.query || !mine(detail.query, c)) return;
    const q = detail.query;
    if (!plain(q)) { if (detail.isCount) deactivate(); return; }
    if (!detail.isCount) { heard(q); kept(true); }
    const a = answer(keyOf(q));
    if (detail.isCount) { if (typeof detail.count === 'number') { a.count = detail.count; a.pages = typeof detail.pages === 'number' ? detail.pages : null; } }
    else { a.products = typeof detail.products === 'number' ? detail.products : 0; a.ids = detail.ids || []; a.endpoint = detail.endpoint || ''; }   // v2-10-8: for the page-2 check
    // (b) mismatch (v2-10-6): StorePass's count for the whole collection is far above Shopify's
    // the addendum's gate (21 OCT, the filters suite on the draft: flesh-and-blood-sealed-product, In Stock Only turned on,
    // StorePass 38 in stock against Shopify's 102 opened the net "capped"): a search with In Stock Only on (the default's
    // or the visit's) counts its in-stock part, which is no measure of the whole collection's: neither the mismatch nor
    // "capped" is judged on it; "zero" (nothing of it in stock at StorePass) and "failed" still are
    const inStockSearch = String(q.in_stock || '') !== '';
    if (detail.isCount && typeof a.count === 'number' && !inStockSearch) {
      if (over(a.count, c)) { mismatch = a.count; activate('mismatch', q); return; }
      if (mismatch !== null && active && active.why === 'mismatch') { deactivate(); }   // StorePass has the collection right again
      mismatch = null;
    }
    if (mismatch !== null) return;                                    // its pages are not the collection's: the net stays
    if (a.products === 0 && a.count === 0) { activate('zero', q); return; }   // (b) zero: nothing on the page AND a total of 0
    // (b) capped (v2-10-7): once both answers are in, StorePass says its one page is all while Shopify holds more.
    // Held across a change of sort or page (a new search key) until a count answer says otherwise, as the mismatch is.
    if (typeof a.count === 'number' && typeof a.products === 'number') {
      latest = q;
      if (!inStockSearch && cappedOf(a, parseInt(q.limit, 10) || 0, c)) {
        // v2-10-8 (item 3a): only when its paging is broken too; while that is asked StorePass's cards stay
        const verdict = checkPaging(a, q, c);
        if (verdict === 'checking') return;
        if (verdict !== 'works') { capped = { products: a.products, count: a.count, paging: verdict }; activate('capped', q); return; }
      }
      if (capped !== null && active && active.why === 'capped') { deactivate(); }        // StorePass gives more than one page again, or its pages work
      capped = null;
    }
    if (capped !== null) return;                                      // the net stays until this search's count has answered
    if (a.products > 0 || a.count > 0) { deactivate(); return; }      // StorePass has this collection (a page past its end is still its own)
  }
  function onFailed(detail) {
    const c = collection();
    if (!c || !detail || !detail.query || !mine(detail.query, c)) return;
    if (!plain(detail.query)) return;                                  // a filtered search that failed is not the whole collection
    heard(detail.query);
    kept(true);
    const a = answers.get(keyOf(detail.query));
    if (mismatch === null && capped === null && a && (a.products > 0 || a.count > 0)) return;   // its twin has answered with products: StorePass is drawing them
    activate('failed', detail.query);
  }
  // Back and Forward (v2-10-6): the address is the truth; StorePass, which re-reads it too, may not search again
  // when only a Shopify filter changed (it does not read those keys).
  function onPop() {
    if (!active) return;
    held = addressFilters();                  // Back / Forward: the address is the truth, filters and all
    setTimeout(() => { if (!active) return; const a = fromAddress(); show(a.sort, a.page); const root = listing(); if (root && controls) syncControls(root); }, 0);
  }

  // ── The pager ──
  function go(page) {
    const url = hrefFor(page);
    const sort = (shown && shown.sort) || (wanted && wanted.sort) || openingBy();
    moved = { page: page, at: Date.now(), drawn: false, answered: 0 };
    // page=<n> into the address, and StorePass told of it (its window.onpopstate re-reads the address), so the
    // address and StorePass's own state agree; then this page of Shopify's listing, without waiting for StorePass
    try {
      window.history.pushState({ dcgFallback: 1 }, '', url.toString());
      if (typeof window.onpopstate === 'function') window.dispatchEvent(new PopStateEvent('popstate', { state: { dcgFallback: 1 } }));
    } catch (_) { window.location.assign(url.toString()); return; }
    show(sort, page);
  }
  function onClick(e) {
    if (!active || !host) return;
    // v2-10-6: on a phone the drawer's "Clear" is StorePass's own button (the panel's "Clear all" is the desktop's):
    // on the net it takes the net's filters off too. StorePass's own press goes on as before.
    const btn = e.target && e.target.closest ? e.target.closest('.store-pass-side-filters button') : null;
    // (the addendum's gate) and the visit's In Stock Only, or a listing on screen the filters in force no longer match
    // (the panel's own handler may have let the visit's choice go first: dcg:storepass-cleared)
    if (btn && /^\s*clear\s*$/i.test(btn.textContent || '') && (filtersOn(addressFilters()) || stockByVisit() || (wanted && filterKey(filters()) !== wanted.filters))) { clearFilters(); return; }
    const a = e.target && e.target.closest ? e.target.closest('a[data-dcg-page]') : null;
    if (!a || !host.contains(a)) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button) return;      // a new tab or window: the link itself
    const page = parseInt(a.getAttribute('data-dcg-page'), 10);
    if (!(page >= 1)) return;
    e.preventDefault();
    e.stopPropagation();
    go(page);
  }

  let queued = false;
  function soon() {
    if (!active || queued) return;
    queued = true;
    setTimeout(() => { queued = false; try { place(); } catch (_) { /* never into StorePass */ } }, 30);
  }

  let started = false;
  function start() {
    if (started) return;                      // once, however often the page says it has been read
    if (!collection()) return;                // not a collection page with StorePass's results on it
    started = true;
    const safe = fn => e => { try { fn(e && e.detail); } catch (_) { /* never into StorePass */ } };
    document.addEventListener('dcg:storepass-search-start', safe(onStart));
    document.addEventListener('dcg:storepass-search', safe(onAnswer));
    document.addEventListener('dcg:storepass-search-failed', safe(onFailed));
    window.addEventListener('popstate', () => { try { onPop(); } catch (_) {} });
    // before StorePass's own handler (window.onpopstate), which searches at once: what Back left in the address is
    // what is held, so that it is not "put back" over the step the customer went back to
    window.addEventListener('popstate', () => { try { if (active) held = addressFilters(); } catch (_) {} }, true);
    const root = listing();
    root.addEventListener('click', e => { try { onClick(e); } catch (_) {} }, true);
    if (typeof MutationObserver !== 'undefined') new MutationObserver(soon).observe(root, { childList: true, subtree: true });
  }

  window.DCG.collectionFallback = {
    active: () => (active ? active.why : null),
    state: () => (shown ? Object.assign({}, shown) : null),
    // v2-10-6: for assets/dcg-storepass-filters.js ("Clear all", the Filters button's count, "Show N results")
    filtersOn: () => (active ? filtersOn(addressFilters()) + (stockByVisit() ? 1 : 0) : 0),     // V3.1.2 (item 1): what the address carries; the default In Stock Only is not one (the addendum's gate: the visit's is)
    clearFilters: () => { if (active) clearFilters(); },
    total: () => (active && shown ? shown.total : null),
    // for checking on a draft theme
    opening: () => (opening ? Object.assign({}, opening) : null),
    offer: () => (offer ? Object.assign({}, offer) : null),
    limit: () => { const c = collection(); return c ? limitOf(c) : null; },
    _plain: plain,
    _sortOf: sortOf,
    _pageOf: pageOf,
    _over: (count, shopify) => over(count, { count: shopify }),
    paging: () => paging,                // v2-10-8 (item 3a): the page-2 check's verdict (null: not asked)
    pagingSaid: () => pagingSaid,
    _capped: (products, count, pages, shopify, size) => cappedOf({ products: products, count: count, pages: pages }, size || 60, { count: shopify }),
    _price: price
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => { try { start(); } catch (_) {} });
  else { try { start(); } catch (_) {} }
})();
